import { Injectable } from '@angular/core';
import { Data } from './data';
import { DataLoaderService } from './data-loader.service'
import { Subject } from 'rxjs/Subject';
import { PriceCalculationService } from './price-calculation.service';

import { SortingService } from "../services/sorting.service";
import { AlternateOptionsService } from './alternate-options.service';

@Injectable()
export class ResetService {
    public expTrim: Data[] = [];
    public expTrimCodes: Data[] = [];
    public expRim: Data[] = [];
    public expRimCodes: Data[] = [];
    public expFactory: Data[] = [];
    public expLocal: Data[] = [];
    public expPackage: Data[] = [];
    public expLocalPackage: Data[] = [];
    public expStandard: Data[] = [];
    public expFactoryCodes: Data[] = [];
    public expLocalCodes: Data[] = [];
    public expPackageCodes: Data[] = [];
    public expLocalPackageCodes: Data[] = [];
    public expStandardCodes: Data[] = [];
    public expColor: Data[] = [];
    public expColorCodes: Data[] = [];
    public expUpholstery: Data[] = [];
    public expUpholsteryCodes: Data[] = [];
    public expAddColor: Data[] = [];
    public expAddColorCodes: Data[] = [];

    constructor(private dataLoaderService: DataLoaderService, private priceCalculationService: PriceCalculationService,
        private sortingService: SortingService,private alternateOptionService:AlternateOptionsService) {
        this.dataLoaderService.data.color.forEach(element => {
            if (element.selected === true) {
                this.expColor.unshift(element);
                this.expColorCodes.unshift(element.code);
            }
        });
        this.dataLoaderService.data.additionalColor.forEach(element => {
            if (element.selected === true) {
                this.expAddColor.unshift(element);
                this.expAddColorCodes.unshift(element.code);
            }
        });
        this.dataLoaderService.data.upholstery.forEach(element => {
            if (element.selected === true) {
                this.expUpholstery.unshift(element);
                this.expUpholsteryCodes.unshift(element.code);
            }
        });
        this.dataLoaderService.data.trim.forEach(element => {
            if (element.selected === true) {
                this.expTrim.unshift(element);
                this.expTrimCodes.unshift(element.code);
            }
        });
        this.dataLoaderService.data.rim.forEach(element => {
            if (element.selected === true) {
                this.expRim.unshift(element);
                this.expRimCodes.unshift(element.code);
            }
        });
        this.dataLoaderService.data.facOptions.forEach(element => {
            if (element.selected === true) {
                this.expFactory.unshift(element);
                this.expFactoryCodes.unshift(element.code);
            }
        });
        this.dataLoaderService.data.options.forEach(element => {
            if (element.selected === true) {
                this.expLocal.unshift(element);
                this.expLocalCodes.unshift(element.code);
            }
        });
        this.dataLoaderService.data.packages.forEach(element => {
            if (element.selected === true) {
                this.expPackage.unshift(element);
                this.expPackageCodes.unshift(element.code);
            }
        });
        this.dataLoaderService.data.localPackagesList.forEach(element => {
            if (element.selected === true) {
                this.expLocalPackage.unshift(element);
                this.expLocalPackageCodes.unshift(element.code);
            }
        });
        this.dataLoaderService.data.stdOpt.forEach(element => {
            if (element.selected === true) {
                this.expStandard.unshift(element);
                this.expStandardCodes.unshift(element.code);
            }
        });
    }

    resetNormalExpert() {
        // for (let i in this.dataLoaderService.data.color) {
        //     if (this.dataLoaderService.data.color[i].selected) {
        //         this.dataLoaderService.data.color[i].selected = false;
        //     }
        // }
        // this.dataLoaderService.flagDictionary.resetColorFlag = true;
       
        
        // this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: [] });

        // for (let i in this.dataLoaderService.data.additionalColor) {
        //     if (this.dataLoaderService.data.additionalColor[i].selected) {
        //         this.dataLoaderService.data.additionalColor[i].selected = false;
        //     }
        // }
        // this.dataLoaderService.flagDictionary.resetAddColorFlag = true;
        // this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [] });

        // for (let i in this.dataLoaderService.data.upholstery) {
        //     if (this.dataLoaderService.data.upholstery[i].selected) {
        //         this.dataLoaderService.data.upholstery[i].selected = false;
        //     }
        // }
        // this.dataLoaderService.flagDictionary.resetUpholsteryFlag = true;
        
        // this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [] });

        this.normalColorReset();
        this.normalUpholsteryReset();
        this.normalAddColorReset();
        this.normalTrimReset();
        this.normalRimReset();
        this.normalFactoryReset();
        this.normalLocalReset();
        this.normalPackageReset();
        this.normalLocalPackageReset();
        this.resetInternalHiddenCodes();
        this.normalStandardReset();

        // resets expert mode
        this.notifyExpertReset();

        // reset configuration ID
        this.alternateOptionService.configurationId = this.dataLoaderService.storeInitialConfigurationID
        this.dataLoaderService.intialConfigurationId = this.dataLoaderService.storeInitialConfigurationID
        //calculates price
        this.priceCalculationService.normalModePriceCalculation();
    }

    normalAddColorReset() {
        if (this.expAddColor.length > 0) {
            for (let i in this.dataLoaderService.data.additionalColor) {
                if (this.dataLoaderService.data.additionalColor[i].code === this.expAddColor[0].code) {
                    this.dataLoaderService.data.additionalColor[i].selected = true;

                } else {
                    this.dataLoaderService.data.additionalColor[i].selected = false;
                }

            }
            this.dataLoaderService.flagDictionary.resetAddColorFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: this.expAddColor });
        } else {
            for (let i in this.dataLoaderService.data.additionalColor) {
                this.dataLoaderService.data.additionalColor[i].selected = false;
            }
            this.dataLoaderService.flagDictionary.resetAddColorFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [] });
        }
    }

    normalColorReset() {
        if (this.expColor.length > 0) {
            for (let i in this.dataLoaderService.data.color) {
                if (this.dataLoaderService.data.color[i].code === this.expColor[0].code) {
                    this.dataLoaderService.data.color[i].selected = true;

                } else {
                    this.dataLoaderService.data.color[i].selected = false;
                }

            }
            this.dataLoaderService.flagDictionary.resetColorFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: this.expColor });
        } else {
            for (let i in this.dataLoaderService.data.color) {
                this.dataLoaderService.data.color[i].selected = false;
            }
            this.dataLoaderService.flagDictionary.resetColorFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: [] });
        }
    }

    normalUpholsteryReset() {
        if (this.expUpholstery.length > 0) {
            for (let i in this.dataLoaderService.data.upholstery) {
                if (this.dataLoaderService.data.upholstery[i].code === this.expUpholstery[0].code) {
                    this.dataLoaderService.data.upholstery[i].selected = true;

                } else {
                    this.dataLoaderService.data.upholstery[i].selected = false;
                }

            }
            this.dataLoaderService.flagDictionary.resetUpholsteryFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: this.expUpholstery });
        } else {
            for (let i in this.dataLoaderService.data.upholstery) {
                this.dataLoaderService.data.upholstery[i].selected = false;
            }
            this.dataLoaderService.flagDictionary.resetUpholsteryFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [] });
        }
    }

    normalRimReset() {
        if (this.expRim.length > 0) {
            for (let i in this.dataLoaderService.data.rim) {
                    if (this.dataLoaderService.data.rim[i].code === this.expRim[0].code) {
                        this.dataLoaderService.data.rim[i].selected = true;
                        
                    } else {
                        this.dataLoaderService.data.rim[i].selected = false;
                    }
                
            }
            this.dataLoaderService.flagDictionary.resetRimFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: [this.expRim] });
        } else {
            for (let i in this.dataLoaderService.data.rim) {
                this.dataLoaderService.data.rim[i].selected = false;
            }
            this.dataLoaderService.flagDictionary.resetRimFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: [] });
        }
    }
    normalTrimReset(){
        if (this.expTrim.length > 0) {
            for (let i in this.dataLoaderService.data.trim) {
                if (this.dataLoaderService.data.trim[i].code === this.expTrim[0].code) {
                    this.dataLoaderService.data.trim[i].selected = true;
                        
                } else {
                        this.dataLoaderService.data.trim[i].selected = false;
                    }
                
            }
           
            this.dataLoaderService.flagDictionary.resetTrimFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [this.expTrim] });
        } else {
            for (let i in this.dataLoaderService.data.trim) {
                this.dataLoaderService.data.trim[i].selected = false;
            }
            this.dataLoaderService.flagDictionary.resetTrimFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [] });
        }
    }
    normalFactoryReset() {
        if (this.expFactory.length > 0) {
            for (let i in this.dataLoaderService.data.facOptions) {
                for (let j in this.expFactory) {
                    if (this.dataLoaderService.data.facOptions[i].code === this.expFactory[j].code) {
                        this.dataLoaderService.data.facOptions[i].selected = true;
                        break;
                    } else {
                        this.dataLoaderService.data.facOptions[i].selected = false;
                    }
                }
            }
            this.dataLoaderService.flagDictionary.resetFactoryFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.expFactory] });
        } else {
            for (let i in this.dataLoaderService.data.facOptions) {
                this.dataLoaderService.data.facOptions[i].selected = false;
            }
            this.dataLoaderService.flagDictionary.resetFactoryFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [] });
        }
    }

    normalLocalReset() {
        if (this.expLocal.length > 0) {
            for (let i in this.dataLoaderService.data.options) {
                for (let j in this.expLocal) {
                    if (this.dataLoaderService.data.options[i].code === this.expLocal[j].code) {
                        this.dataLoaderService.data.options[i].selected = true;
                        break;
                    } else {
                        this.dataLoaderService.data.options[i].selected = false;
                    }
                }
            }
            this.dataLoaderService.flagDictionary.resetLocalOptionsFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.expLocal] });
        } else {
            for (let i in this.dataLoaderService.data.options) {
                this.dataLoaderService.data.options[i].selected = false;
            }
            this.dataLoaderService.flagDictionary.resetLocalOptionsFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [] });
        }

    }
    normalPackageReset() {
        if (this.expPackage.length > 0) {
            for (let i in this.dataLoaderService.data.packages) {
                for (let j in this.expPackage) {
                    if (this.dataLoaderService.data.packages[i].code === this.expPackage[j].code) {
                        this.dataLoaderService.data.packages[i].selected = true;
                        break;
                    } else {
                       this.dataLoaderService.data.packages[i].selected = false;
                    }
                }
            }
            this.dataLoaderService.flagDictionary.resetPackageOptionsFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.expPackage] });
        } else {
            for (let i in this.dataLoaderService.data.packages) {
                this.dataLoaderService.data.packages[i].selected = false;
            }
            this.dataLoaderService.flagDictionary.resetPackageOptionsFlag = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [] });
        }
    }
    normalLocalPackageReset() {
        if (this.expLocalPackage.length > 0) {
            for (let i in this.dataLoaderService.data.localPackagesList) {
                for (let j in this.expLocalPackage) {
                    if (this.dataLoaderService.data.localPackagesList[i].code === this.expLocalPackage[j].code) {
                        this.dataLoaderService.data.localPackagesList[i].selected = true;
                        break;
                    } else {
                        this.dataLoaderService.data.localPackagesList[i].selected = false;
                    }
                }
            }
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.expLocalPackage] });
        } else {
            for (let i in this.dataLoaderService.data.localPackagesList) {
                this.dataLoaderService.data.localPackagesList[i].selected = false;
            }
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [] });
        }
    }
    resetInternalHiddenCodes() {
        if (this.dataLoaderService.vehicleInfo.urlFlag == '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
            this.dataLoaderService.internalCodes = this.dataLoaderService.gccInitialInternalCodes;
            this.dataLoaderService.gccInternalCodesAccept = this.dataLoaderService.internalCodes;
            this.dataLoaderService.hiddenOptions = this.dataLoaderService.gccInitialHiddenOptions;
        }

        if (this.dataLoaderService.vehicleInfo.urlFlag == '2' || this.dataLoaderService.vehicleInfo.urlFlag === '3') {
            this.dataLoaderService.hiddenOptions = this.dataLoaderService.ppmInitialHiddenOptions;
            this.dataLoaderService.internalCodes = this.dataLoaderService.ppmInitialInternalOptions;
            this.dataLoaderService.amendInternalCodes = this.dataLoaderService.ppmInitialInternalOptions;
        }
    }
    normalStandardReset() {
        if (this.expStandard.length > 0) {
            for (let i in this.dataLoaderService.data.stdOpt) {
                for (let j in this.expStandard) {
                    if (this.dataLoaderService.data.stdOpt[i].code === this.expStandard[j].code) {
                        this.dataLoaderService.data.stdOpt[i].selected = true;
                        break;
                    } else {
                        this.dataLoaderService.data.stdOpt[i].selected = false;
                    }
                }
            }
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalStandard", data: [this.expStandard] });
            this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertStandard", data: [this.expStandard] });
        } else {
            for (let i in this.dataLoaderService.data.stdOpt) {
                this.dataLoaderService.data.stdOpt[i].selected = false;
            }
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalStandard", data: [] });
            this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertStandard", data: [] });

        }      

        this.sortingService.sortCodes(this.dataLoaderService.data.color, true)
        this.sortingService.sortCodes(this.dataLoaderService.data.additionalColor, true)
        this.sortingService.sortCodes(this.dataLoaderService.data.rim, true)
        this.sortingService.sortCodes(this.dataLoaderService.data.trim, true)
        this.sortingService.sortCodes(this.dataLoaderService.data.facOptions, true)
        this.sortingService.sortCodes(this.dataLoaderService.data.options, true)
        this.sortingService.sortCodes(this.dataLoaderService.data.stdOpt, true)
        this.sortingService.sortCodes(this.dataLoaderService.data.upholstery, true)
        this.sortingService.sortCodes(this.dataLoaderService.data.technicalDataItems, false)
        this.sortingService.sortCodes(this.dataLoaderService.data.packages, true)
        this.sortingService.sortCodes(this.dataLoaderService.data.localPackagesList, true)
    }

    //Expert Reset
    private notifyReset = new Subject<any>();
    notifyObservable$ = this.notifyReset.asObservable();

    public notifyExpertReset() {
        this.notifyReset.next();
    }

    //Special Reset
    public notifySpecialReset() {
        this.notifyReset.next();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/reset.service.ts